import React from 'react';
/* @ts-ignore:next-line */
import { MessageBanner, TextLink } from '@folio/stripes/components';
import { t } from '../../../../services';
export var SuccessRefreshSection = function (_a) {
    var shouldShow = _a.shouldShow, _b = _a.recordsCount, recordsCount = _b === void 0 ? 0 : _b, _c = _a.onViewListClick, onViewListClick = _c === void 0 ? function () { } : _c;
    if (!shouldShow) {
        return React.createElement("div", null);
    }
    return (React.createElement("div", { style: { marginBottom: '15px' } },
        React.createElement(MessageBanner, { show: shouldShow, type: "success" },
            React.createElement("span", { style: { color: 'black' } }, (t('status-toast.success.refresh-complete', { count: recordsCount }))),
            React.createElement(TextLink, { style: { cursor: 'pointer', fontWeight: 'bold' }, onClick: onViewListClick },
                React.createElement("strong", null, t('status-toast.success.link'))))));
};
